import React from "react";
import { OrganizationServicesOffered } from "@common/types/organization";
import { servicesOfferedLabels } from "@components/entity/constants";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const options: FilterMultiselectOption[] = Object.values(
    OrganizationServicesOffered,
).map((service) => ({
    value: service,
    label: servicesOfferedLabels[service],
    searchableLabel: String(servicesOfferedLabels[service]),
}));

export const ServicesFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.services ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    onChange({
                        services:
                            val.length > 0
                                ? (val as OrganizationServicesOffered[])
                                : undefined,
                    });
                }}
                name="services"
                onBlur={noop}
            />
        </div>
    );
};
